import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faCheck } from '@fortawesome/free-solid-svg-icons';
import { useSettings } from '../hooks/useSettings';

const FontSizeSettings = () => {
  const navigate = useNavigate();
  const { settings, updateSettings } = useSettings();
  
  const fontSizes = ['小', '中', '大', '特大'];
  
  const handleSelectFontSize = (size) => {
    updateSettings({ fontSize: size });
    navigate('/settings');
  };
  
  return (
    <div className="bg-[#f9f9f9] min-h-screen">
      {/* Main Content */}
      <div className="p-5">
        {/* Navigation Header */}
        <div className="flex justify-between items-center mb-6">
          <button 
            className="text-blue-500 flex items-center"
            onClick={() => navigate('/settings')}
          >
            <FontAwesomeIcon icon={faChevronLeft} className="mr-1" />
            <span>返回</span>
          </button>
          <h2 className="text-xl font-bold">字体大小</h2>
          <div className="w-16"></div> {/* Spacer for alignment */}
        </div>

        {/* Font Size Options */}
        <div className="bg-white rounded-xl shadow-sm">
          {fontSizes.map((size, index) => (
            <div 
              key={size}
              className={`p-4 flex justify-between items-center cursor-pointer ${
                index < fontSizes.length - 1 ? 'border-b border-gray-100' : ''
              }`}
              onClick={() => handleSelectFontSize(size)}
            >
              <span className={`font-medium ${
                size === '小' ? 'text-sm' : 
                size === '中' ? 'text-base' : 
                size === '大' ? 'text-lg' : 'text-xl'
              }`}>
                {size}
              </span>
              {settings.fontSize === size && (
                <FontAwesomeIcon icon={faCheck} className="text-blue-500" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FontSizeSettings;